import {
  TRACKING_AD_FORM,
  adForm,
  VIEWER_INITIALIZED,
  VIEWER_BROWSE,
} from '../../../actions'
import { selectTrackingAdForm, selectUserCookiesPreference } from '../../../selectors'

import { OT_TARGETING_ADS_PREFERENCE } from '../../../../utils/consts'

const adFormHandler = () => next => action => {
  if (action.type === TRACKING_AD_FORM) {
    const { args } = action.payload
    if (window.adf) window.adf.track(...args)
  }

  next(action)
}

const onViewerInitialized = ({ getState, dispatch }) => next => action => {
  next(action)
  const { host } = window.location
  const state = getState()
  const isPreferenceExpressed = selectUserCookiesPreference(OT_TARGETING_ADS_PREFERENCE)(state)
  const accessPixelEvent = `Access on ${host}`

  if (action.type === VIEWER_INITIALIZED && isPreferenceExpressed) {
    const adFormPixels = selectTrackingAdForm(state)

    adFormPixels.forEach(pixel => {
      dispatch(adForm(pixel, 'Pixel Apertura Volantino'))

      if (accessPixelEvent) {
        dispatch(adForm(pixel, accessPixelEvent))
      }
    })
  }
}

const onViewerBrowse = ({ getState, dispatch }) => next => action => {
  next(action)
  const state = getState()
  const isPreferenceExpressed = selectUserCookiesPreference(OT_TARGETING_ADS_PREFERENCE)(state)

  if (action.type === VIEWER_BROWSE && isPreferenceExpressed) {
    const adFormPixels = selectTrackingAdForm(state)

    adFormPixels.forEach(pixel => (
      dispatch(adForm(pixel, 'Pixel Sfoglio Volantino'))
    ))
  }
}

export default [
  adFormHandler,
  onViewerInitialized,
  onViewerBrowse,
]
